import Activities from '~/activities';

// eslint-disable-next-line no-new
new Activities();
